import * as React from 'react'

import {
  HorizontalAlignment,
  Direction,
} from '@thg-commerce/gravity-patterns/ProductBlock/types'
import { spacing } from '@thg-commerce/gravity-theme'

import { Title } from './styles'

export interface ListProps {
  children: React.ReactNode
  useAlternateTitleStyle?: boolean
  title?: string
  alignment?: HorizontalAlignment
  direction?: Direction
  className?: string
}

export const List = (props: ListProps) => {
  return (
    <div className={props.className}>
      {props.title && (
        <Title
          useAlternateTitleStyle={props.useAlternateTitleStyle || false}
          alignment={props.alignment}
        >
          {props.title}
        </Title>
      )}
      <ul
        style={{
          display: 'flex',
          flexDirection: props.direction || 'column',
          margin: `${spacing(4)} 0`,
          gap: `${spacing(3)}`,
        }}
      >
        {props.children}
      </ul>
    </div>
  )
}
